import React from 'react';

const TechnologyChips = ({ technologies = '', technologyLinks = {}, flagshipTech = '' }) => (
  <div className="flex flex-wrap gap-2.5">
    {technologies.split(',').map((tech) => tech.trim()).filter(Boolean).map((tech) => {
      const href = technologyLinks[tech];
      const isFlagship = tech === flagshipTech;
      const baseClass = 'inline-flex items-center gap-2 rounded-full border px-3.5 py-2 text-sm leading-5';

      if (!href) {
        return (
          <span key={tech} className={`${baseClass} border-slate-600/40 bg-slate-800/40 text-slate-300`}>
            {tech}
          </span>
        );
      }

      return (
        <a
          key={tech}
          href={href}
          target="_blank"
          rel="noopener noreferrer"
          aria-label={`${tech} product page (opens in a new tab)`}
          className={`${baseClass} font-semibold bg-gradient-to-br shadow-sm transition-all duration-200 hover:border-accent hover:shadow-lg hover:shadow-accent/10 motion-safe:hover:-translate-y-0.5 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-accent focus-visible:ring-offset-2 focus-visible:ring-offset-background-dark ${
            isFlagship
              ? 'from-accent/25 to-accent/10 border-accent/60 text-accent'
              : 'from-slate-700/60 to-slate-800/60 border-accent/30 text-sky-200 hover:text-accent'
          }`}
        >
          <span className={`h-1.5 w-1.5 shrink-0 rounded-full ${isFlagship ? 'bg-accent' : 'bg-accent/60'}`} aria-hidden="true" />
          {tech}
          <svg className="h-3.5 w-3.5 shrink-0 opacity-75" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.75} d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" />
          </svg>
        </a>
      );
    })}
  </div>
);

export default TechnologyChips;
